import { z } from 'zod';

import { BaseToolResultSchema } from './baseResult';

export const SubmitTranslationsEntrySchema = z.object({
  id: z.string().describe('Caller-supplied identifier for this entry, echoed back unchanged.'),
  originalText: z.string().describe('The source text being translated.'),
  translatedText: z.string().describe('The translation, in targetLanguage.'),
});

export type SubmitTranslationsEntry = z.infer<typeof SubmitTranslationsEntrySchema>;

export const SubmitTranslationsArgsSchema = z.object({
  targetLanguage: z.string().describe('The language to translate into, e.g. "Spanish" or "Japanese".'),
  translations: z.array(SubmitTranslationsEntrySchema).describe('The entries to translate.'),
});

export type SubmitTranslationsArgs = z.infer<typeof SubmitTranslationsArgsSchema>;

export const SubmitTranslationsResultSchema = BaseToolResultSchema.extend({
  message: z.string(),
  targetLanguage: z.string(),
  translations: z.array(SubmitTranslationsEntrySchema),
});

export type SubmitTranslationsResult = z.infer<typeof SubmitTranslationsResultSchema>;

export const SUBMIT_TRANSLATIONS_TOOL_NAME = 'submit_translations';

export const SUBMIT_TRANSLATIONS_TOOL_DESCRIPTION =
  'Submit a batch of already-translated text entries for a target language.';

export const SUBMIT_TRANSLATIONS_TOOL = {
  description: SUBMIT_TRANSLATIONS_TOOL_DESCRIPTION,
  name: SUBMIT_TRANSLATIONS_TOOL_NAME,
  parameters: SubmitTranslationsArgsSchema.toJSONSchema(),
};
